import React, { useState } from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { ListItemIcon, IconButton } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { Comment, EditTwoTone } from '@material-ui/icons';
import SideBarListStyles from '../../styles/SideBarListStyle';
import ShowProgress from '../ui/Backdrop';

import Check from '../../assets/SvgCheck';

import { getCheckedAssignedInstr, getCheckedInstr } from '../../redux/actions/DealershipActions';
import AddGuideInstructor from './AddGuideInstructor';
import Image from '../common/Image';

export default function SelectedListItem(props) {
  const instrlist = props.listVal;
  const classes = SideBarListStyles();
  const dispatch = useDispatch();

  const [openEditGuideInstructor, setOpenEditGuideInstructor] = useState(false);
  const [selectedInstr, setSelectedInstr] = useState(0);

  const checkedVals = useSelector((state) => state.getCheckedAssignedInstr.checkedAssignedInstr);
  const checkedInstructors = useSelector((state) => state.getCheckedInstr.checkedInstructors);

  const handleCloseAddGuideInstructor = () => {
    setOpenEditGuideInstructor(false);
  };
  const handleListItemClick = (event, index, key) => {
    if (checkedVals) {
      const currentIndex = checkedVals?.indexOf(key);
      const currentSelIndex = checkedInstructors?.indexOf(index);
      const newChecked = [...checkedVals];
      const newSel = [...checkedInstructors];

      if (currentSelIndex === -1) {
        newChecked?.push(key);
        newSel?.push(index);
      } else {
        newChecked?.splice(currentIndex, 1);
        newSel?.splice(currentSelIndex, 1);
      }

      dispatch(getCheckedAssignedInstr(newChecked));
      dispatch(getCheckedInstr(newSel));
    }
  };

  return (
    <div
      className={classes.root}
      style={{
        height: '100%',
        overflow: 'auto',
        marginTop: '16px',
      }}
    >
      <List component="nav" aria-label="secondary mailbox folder">
        {instrlist?.map((data, key) => {
          const index = data.id;
          return (
            <div
              key={data.id}
              className={checkedInstructors?.includes(data.id) ? classes.highlightItemLeft : ''}
              style={{ marginBottom: '10px' }}
            >
              <ListItem
                key={data.id}
                secondaryAction={
                  <IconButton edge="end" aria-label="comments">
                    <Comment />
                  </IconButton>
                }
                button
                selected={checkedInstructors?.includes(data.id)}
                className={
                  checkedInstructors?.includes(data.id) ? classes.listStylingInstr : classes.listStylingInstrUn
                }
                onClick={(event) => handleListItemClick(event, index, key)}
              >
                {checkedInstructors?.includes(data.id) ? (
                  <ListItemIcon>
                    <Check />
                  </ListItemIcon>
                ) : null}
                <ListItemIcon>
                  <Image alt="" src={data.thumbnail} style={{ width: '44px', height: '44px' }} />
                </ListItemIcon>
                <ListItemText
                  style={{ width: 'min-content' }}
                  primary={
                    <div>
                      <p
                        className={
                          `${checkedInstructors?.includes(data.id)}`
                            ? classes.listTextSelected
                            : classes.listTextNonSelected
                        }
                      >
                        {data.name}
                      </p>
                    </div>
                  }
                  secondary={
                    <div>
                      <div className={classes.listSubTextSelected}></div>
                    </div>
                  }
                />

                <EditTwoTone
                  onClick={(e) => {
                    e.stopPropagation();
                    setSelectedInstr(data.id);
                    setOpenEditGuideInstructor(true);
                  }}
                />
              </ListItem>
            </div>
          );
        })}
      </List>
      {<ShowProgress />}
      {openEditGuideInstructor && (
        <AddGuideInstructor open type="INSTRUCTOR" edit selId={selectedInstr} close={handleCloseAddGuideInstructor} />
      )}
    </div>
  );
}
